import { render, staticRenderFns } from "./AddIncomeType.vue?vue&type=template&id=5bc833da&scoped=true&"
import script from "./AddIncomeType.vue?vue&type=script&lang=js&"
export * from "./AddIncomeType.vue?vue&type=script&lang=js&"
import style0 from "./AddIncomeType.vue?vue&type=style&index=0&id=5bc833da&prod&lang=scss&scoped=true&"
import style1 from "./AddIncomeType.vue?vue&type=style&index=1&id=5bc833da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc833da",
  null
  
)

export default component.exports